import { render } from "./ProductManage.vue?vue&type=template&id=36feac10&scoped=true"
import script from "./ProductManage.vue?vue&type=script&lang=js"
export * from "./ProductManage.vue?vue&type=script&lang=js"

import "./ProductManage.vue?vue&type=style&index=0&id=36feac10&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36feac10"]])

export default __exports__